var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"corner-box"},[_c('div',{staticClass:"left-top-corner"}),_c('div',{staticClass:"left-bottom-corner"}),_c('div',{staticClass:"right-bottom-corner"}),_c('div',{staticClass:"right-top-corner"}),_c('div',{staticClass:"content-slot"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }